/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import {
    BrowserRouter as Router,
    matchPath, Redirect, Route, Switch
} from "react-router-dom";
import { xs_sessionToken } from '.';
import CheckTicketPopup from './check-ticket/CheckTicketPopup';
import Betslip from './common/betslip/Betslip';
import BetslipAlt from './common/betslip/BetslipAlt';
import BetslipBottomBar from './common/betslip/BetslipBottomBar';
import RouletteHandler from './common/RouletteHandler';
import FastbetPopup from './common/fast-bet/FastbetPopup';
import MessageInfo from './common/MessageInfo';
import BetslipConf from './data/betslip/BetslipConf';
import CashoutConfigurationCtx from './data/cashout/CashoutConfigurationCtx';
import BonusConf from './data/betslip/BonusConf';
import UserConf from './data/betslip/UserConf';
import ControlPanelConf from './data/control-panel-context/ControlPanelConf';
import FastbetConf from './data/fastbet/FastbetConf';
import LandingRequestedOpsConf from './data/landing/LandingRequestedOpsConf';
import CheckBet from './data/my-bets/checkbet/CheckBet';
import MyBets from './data/my-bets/MyBets';
import CheckSystemBets from './data/my-bets/checksystembets/CheckSystemBets'
import TicketPrinterConf from './data/printer/TicketPrinterConf';
import ShopReceiptPrinterConf from './data/printer/ShopReceiptPrinterConf';
import PvrConf from './data/pvr/PvrConf';
import { SeoContext, useSeoContext } from './data/seo/SeoContextProvider';
import { fetchSeoConfig } from './data/seo/seoUtils';
import ShopConf from './data/shop/ShopConf';
import { concatUrlPathnames, handleHistory } from './data/sport-utils';
import { getAccountIds } from './data/utils/getAccountIds';
import { getConfiguration } from './data/utils/configuration';
import { getQueryStringVariable } from './data/utils/getQueryStringVariable';
import InitData from './InitData';
import { appConfig } from './appConfig';
import { getLabel, labels } from './data/labels';
import Live from './live/Live';
import { FiltersProvider } from './prematch/FiltersContext';
import Prematch from './prematch/Prematch';
import PrematchDataFetcher from './prematch/PrematchDataFetcher';
import { handleMenuVisibility, initTopButtonScrollHandler, isBetslipPlayDirectRequest, selectSectionButton, setTabLayerMobileHeight } from './utils/sport-effects';
import AppModal from './data/modal/AppModal';
import BetslipVariation from './data/betslip/BetslipVariation';
import PurchaseResponseMessage from './data/betslip/PurchaseResponseMessage';


import './assets/css/carrelloMobile.css';
import './assets/css/sport-mobile.css';
import BetOptionsModalContent from './data/betslip/BetOptionsModalContent';

export const AppContext = React.createContext(null);

function App() {
    const conf = window.appConfig? getConfiguration() : null;
    const [seoConfigFetched, setSeoConfigFetched] = useState(false);
    const [location,setLocation] = useState(null);
    const [isLive, setIsLive] = useState(false);
    const [reloadPrematch, setReloadPrematch] = useState(false);
    const [seoContext] = useSeoContext();
    
    function hideCgHeader() {
    	if (!window.appConfig.SHOP_MODE) {
        	window.$('.cg-top-header').addClass('d-none');
        	window.$('.cg-menuTabMobile').addClass('d-none');
        	window.$('#cg_exa-mobileSportAppContainer').addClass('remove-padding-top');
    	} else {
    		window.$('#react-anchor-div').removeClass('padding50');
    		window.$('#header').addClass('hideme');
    		window.$('#xsport-menu').addClass('hideme');
    	}
    }
    
    function showCgHeader() {
    	if (!window.appConfig.SHOP_MODE) {
    		window.$('.cg-top-header').removeClass('d-none');
    		window.$('.cg-menuTabMobile').removeClass('d-none');
    		window.$('#cg_exa-mobileSportAppContainer').removeClass('remove-padding-top');    		
    	} else {
    		window.$('#react-anchor-div').addClass('padding50');
    		window.$('#header').removeClass('hideme');
    		window.$('#xsport-menu').removeClass('hideme');
    	}
    }

    function addBodyClasses(){
        const body = document.getElementById('xs-mobile') || document.body;
        const isAppIOS = appConfig?.IS_APP_IOS || getQueryStringVariable('isAppIOS');
        const isAppAndroid = appConfig?.IS_APP_ANDROID || getQueryStringVariable('isAppAndroid');
        const className = isAppIOS?'xs-ios-wrapper':isAppAndroid?'xs-android-wrapper':'';
        if(body && className){
            if(!body.classList?.contains(className)){
                body.classList.add(className);
            }
        }
    }
    
    const [appContext, setAppContext] = useState({
        isUserLogged: useRef(false),
        location: useRef(null),
        seoRoutePath: {},
        resetLive: false,
        showBetslip: null,
        showMyBets: null,
        showCheckBet: null,
        showCheckSystemBets: null,
        showFastbetPopup: false,
        showCheckTicketPopup: false,
        openTicketScanner: false,
        adviceBonusCollapsed:false,
        handleOpenFromPath: true,
        historyBackPressed: false,
        pageNotFound: false,
        betslipVariationData: null,
        purchaseResponseData: null,
        hideMenu: isHideMenu(),
        update(updt) {
            setAppContext(prev => {
                return {...prev, ...updt};
            });
        },
        setHandleOpenFromPath(handleOpenFromPath){
            this.update({handleOpenFromPath});
        },
        setHistoryBackPressed(historyBackPressed){
            this.update({historyBackPressed});
        },
        setPageNotFound(pageNotFound){
            this.update({pageNotFound});
        },
        setIsUserLogged(isLogged) {
            this.isUserLogged.current = isLogged;
        },
        setLocation(location) {
            this.location.current = location;
        },
        setSeoRoutePath(seoPathname, defaultPathname) {
            this.update({seoRoutePath: JSON.parse('{"'+seoPathname+'":"'+defaultPathname+'"}')});
        },
        setResetLive(resetLive) {
            this.update({resetLive});
        },
        toggleBetslip() {
            if (isBetslipPlayDirectRequest() && !this.isUserLogged.current) {
                const showLogin = window.appConfig?.HANDLERS?.['showLoginMask'];
                if (typeof showLogin === 'function') {
                    showLogin();
                } else {
                    console.log("Please login");
                }
                return;
            }
        	if (this.showBetslip) {
        		// it has to be hidden
        		showCgHeader();
        	} else {
        		hideCgHeader();
        	}
            this.update({showBetslip: this.showBetslip === null? true: !this.showBetslip});
        },
        hideBetslip() {
        	showCgHeader();
            this.update({showBetslip :false});
        },
        openBetslip() {
        	this.update({showBetslip : true});
        	hideCgHeader();
        },
        isMyBetsShowable() {
            const accountIds = getAccountIds();
            if (window.injectXSport === undefined) {
                return accountIds != null;
            } else {
                return appContext.isUserLogged.current || accountIds != null;
            }
        },
        toggleMyBets() {
           if (this.isMyBetsShowable()) {
                this.update({showMyBets: this.showMyBets == null ? true: !this.showMyBets});
           } else {
                const showLogin = window.appConfig?.HANDLERS?.['showLoginMask'];
                if (typeof showLogin === 'function') {
                    showLogin();
                } else if ((xs_sessionToken == null || xs_sessionToken.length === 0) && typeof window.appConfig?.HANDLERS?.toggleLogin === 'function') {
                    window.appConfig.HANDLERS.toggleLogin(true);
                } else {
                    console.log("Please login");
                }
           }
        },
        hideMyBets() {
            this.update({showMyBets :false});
        },
        toggleCheckBet() {
            if (this.showCheckBet) {
        		// it has to be hidden
        		showCgHeader();
        	} else {
        		hideCgHeader();
        	}
            this.update({showCheckBet :this.showCheckBet === null? true: !this.showCheckBet});
        },
        toggleCheckSystemBets() {
            if (this.showCheckSystemBets) {
        		// it has to be hidden
        		showCgHeader();
        	} else {
        		hideCgHeader();
        	}
            this.update({showCheckSystemBets :this.showCheckSystemBets === null? true: !this.showCheckSystemBets});
        },
        toggleFastbetPopup() {
            this.update({showFastbetPopup: !this.showFastbetPopup});
        },
        toggleCheckTicketPopup(openTicketScanner) {
            this.update({showCheckTicketPopup: !this.showCheckTicketPopup, openTicketScanner: openTicketScanner});
        },
        toggleAdviceBonus(){
            this.update({adviceBonusCollapsed: !this.adviceBonusCollapsed});
        },
        showBetslipVariationModal : function (selections, advise, purchaseFunction, amountData){
			const betslipVariationData = {
					selections,
					advise,
					purchaseFunction,
					amountData
			}
			this.update({betslipVariationData});
		},
		hideBetslipVariationModal : function(){
			const betslipVariationData = null;
			this.update({betslipVariationData});
		},
        showPurchaseMessageModal : function(message, type){
			const purchaseResponseData = {
				message,
				type
			};
			this.update({purchaseResponseData});
		},
        hidePurchaseMessageModal : function (){
			const purchaseResponseData = null;
			this.update({purchaseResponseData});
		},
        showBetOptionsModal : function (options, type, checkedValue, selectorFunction){
			const labelLeft = type === 'freebet'? 'betslip.freebet.title_part1' : 'betslip.fun_bonus.title_part1';
			const labelRight = type === 'freebet'? 'betslip.freebet.title_part2' : 'betslip.fun_bonus.title_part2';
			const modalHeader = [getLabel(labelLeft), getLabel(labelRight).toUpperCase()].join(' ');
			const betOptionsData = {
					options,
					type,
					checkedValue,
					selectorFunction,
					modalHeader
			}
			this.update({betOptionsData});
		},
		
		hideBetOptionsModal : function(){
			const betOptionsData = null;
			this.update({betOptionsData});
		},
    });

    useEffect(function() {
        if(!window.showBetslipVariationModal){
            window.showBetslipVariationModal = function(selections, advise, purchaseFunction, amountData){
               appContext.showBetslipVariationModal(selections, advise, purchaseFunction, amountData);			
            }
        }
        if(!window.showModalPurchaseMessage){
            window.showModalPurchaseMessage = function(message, type){
                appContext.showPurchaseMessageModal(message, type);		
            }
        }
        if(!window.hideModalPurchaseMessage){
            window.hideModalPurchaseMessage = function(){
                appContext.hidePurchaseMessageModal();		
            }
        }
        
        if(!window.showBetOptionsModal){
            window.showBetOptionsModal = function(options, type, checkedValue, selectorFunction){
               appContext.showBetOptionsModal(options, type, checkedValue, selectorFunction);			
            }
        }
        if(!window.hideBetOptionsModal){
            window.hideBetOptionsModal = function(){
               appContext.hideBetOptionsModal();		
            }
        }
    }, []);

    useEffect(function() {
        initTopButtonScrollHandler();
        addBodyClasses();
    }, []);

    useEffect(function() {
        appContext.setLocation(location);
        if((location||null)!=null)
            handleSelectButton(location);
    }, [location]);

    useEffect(function() {
        if (appContext.showBetslip) {
            handleSelectButton('betslip')
            appContext.hideMyBets();
			onBetslipToggle && onBetslipToggle(true);
        } else {
            appContext.location.current === 'betslip'? handleSelectButton('prematch') : handleSelectButton(appContext.location.current);
			onBetslipToggle && onBetslipToggle(false);
        }
    }, [appContext.showBetslip]);

    useEffect(function() {
        if (appContext.showMyBets) {
            handleSelectButton('mybet')
        } else {
            appContext.location.current === 'mybets'? handleSelectButton('prematch') : handleSelectButton(appContext.location.current);
        }
    }, [appContext.showMyBets]);

    function isLiveSection(section) {
        return appConfig.ROUTES['live']?.[section] ?? section === 'live';
    }
	
	const onBetslipToggle = window.appConfig?.HANDLERS?.['onBetslipToggle'];

    window.toggleBetslip = function() {
        appContext.toggleBetslip();
		onBetslipToggle && onBetslipToggle(!appContext.showBetslip || false);
    }
    
    window.openBetslip = function() {
    	appContext.openBetslip();
		onBetslipToggle && onBetslipToggle(true);
    }
    window.hideBetslip = function() {
    	appContext.hideBetslip();
		onBetslipToggle && onBetslipToggle(false);
    }

    window.toggleMyBets = function() {
        appContext.toggleMyBets();
    }
    
    window.openSection = function(section) {
        const isLive = isLiveSection(section);
        setLocation(section);
        setIsLive(isLive);

        appContext.setPageNotFound(false);
        appContext.hideBetslip();
        appContext.hideMyBets();
        if (section === appContext.location.current) {
            appContext.setResetLive(true);
        }
        handleHistory( concatUrlPathnames(appConfig.BASENAME,appConfig.ROUTES.pathFromSection(isLive?'live':'prematch',section)));

        if (section === 'prematch' && section === appContext.location.current) {
            setReloadPrematch(!reloadPrematch);
            return;
        }
       
        
    }

    function handleSelectButton(section) {
        const selectMenuButton = appConfig.HANDLERS?.['selectMenuButton'];
        if (typeof selectMenuButton === 'function') {
            selectMenuButton(section);
        }
        if (appConfig.MENU['show']) {
			if(appContext.showBetslip){
                selectSectionButton('betslip');
            }else{
                selectSectionButton(section);
            }
        }
    }

    function handleOpenFromPath(matchingRoute,location) {
        const last = location.pathname.substring((location.pathname.lastIndexOf('/')));
        const suffix = last && last.match(/(_-?\d+){1,5}/mg);
        const parts = suffix?.[0]?.split("_") ?? [];

        const open = {};
        parts.splice(0, 1);

        /* if(parts.length == 0){
                open.dateFilter = true;
        }else{ */
            switch(parts.length) {
                case 1: 
                    open.sport = {
                        sportId: parts[0]
                    }
                    break;
                case 2: 
                    open.country = {
                        sportId: parts[0],
                        countryId: parts[1]
                    }
                    break;
                case 3: 
                    open.sport = {
                        sportId: parts[0]
                    }
                    open.tournament = {
                        sportId: parts[0],
                        countryId: parts[1],
                        tournamentId: parts[2]
                    }
                    break;
                case 5: 
                    open.sport = {
                        sportId: parts[0]
                    }
                    open.tournament = {
                        sportId: parts[0],
                        countryId: parts[1],
                        tournamentId: parts[2]
                    }
                    open.match = {
                        pal: parts[3],
                        avv: parts[4]
                    }
                    break;
                default:
                    return null;
            }
        /* } */

        
        return open;
    }

    function setSeoPathName(pathname, location) {
        if (pathname) {
            if (location) {
                const locationPathname = isLiveSection(location) ? appConfig.ROUTES['live'][location] : appConfig.ROUTES['prematch'][location];
                const index = pathname.indexOf(locationPathname) + locationPathname.length;
                if (pathname.substring(index)) {
                    seoContext.setPathname(pathname.replace(locationPathname,''), location);
                } else {
                    seoContext.setPathname(pathname, location);
                }
            } else {
                seoContext.setPathname(pathname, location);
            }
        }
    }

    function routePrematch(props,routeNotFound) {
        const openFromPath = handleOpenFromPath(props.match,props.location);
        const s = location || routeNotFound?'prematch':appConfig.ROUTES.sectionFromPath(props.match.url,appConfig.ROUTES['prematch']);
        //console.log(appContext.location.current+" "+seoContext.location)
        if (appContext.location.current != seoContext.location) {
            setSeoPathName(props.location.pathname, s);
        }
        handleSelectButton(s);
        appContext.setLocation(s);
        handleMenuVisibility(appContext.location.current,appContext);
        setTabLayerMobileHeight();
    
        return (
            <>
                {(location == null || location === 'prematch' /*|| !isLive*/) &&
                    <PrematchDataFetcher>
                        <FiltersProvider>
                            <Prematch section={s} openFromPath={openFromPath} key={reloadPrematch} routeNotFound={routeNotFound} routeProps={props} />
                        </FiltersProvider>
                    </PrematchDataFetcher>
                }
            </>
        );
    }

    function routeLive(props) {
        const s = location || appConfig.ROUTES.sectionFromPath(props.match.url, appConfig.ROUTES['live']);
        //console.log(appContext.location.current+" "+seoContext.location)
        if (appContext.resetLive || appContext.location.current != seoContext.location) {
            setSeoPathName(props.location.pathname, s);
        }
        handleSelectButton(s);
        appContext.setLocation(s)
        handleMenuVisibility(appContext.location.current,appContext);
        setTabLayerMobileHeight();

        if (location == null || isLive) {
            return <Live section={s} />;
        } else {
            return <></>;
        }
    }

    /*function routeNoMatching(props) {
        return (
            <RouteNoMatching {...props} />
        );
    }*/

    function routeNoMatching(props) {
        return routePrematch(props,true);
    } 

    function setUserLogged(isLogged) {
        appContext.setIsUserLogged(isLogged)
    }

    function isSeoOff() {
        return (getQueryStringVariable('seoOff') === 'true' || getQueryStringVariable('seoDisabled') === 'true' || (appConfig && appConfig['seoOff'] == true) ) ? true : false;
    }

    function isHideMenu(){
        return getQueryStringVariable('hideMenu')=='true';
    }

    useEffect(function() {
        if ((!(window.cg_SYSTEM_CODE || window.appConfig.SHOP_MODE ) && !isSeoOff() ) || (appConfig && appConfig['SEO_ENABLED'])) {
            try {
                fetchSeoConfig(setSeoConfigFetched,true);
            } catch(err) {
                setSeoConfigFetched(true);
                console.log(err);
                alert(err);
            }
        } else {
            setSeoConfigFetched(true);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('popstate', (event) => {
            try {
                const pathname = window.location.pathname.substring(window.location.pathname.indexOf(appConfig.BASENAME)+appConfig.BASENAME.length);
                let s = appConfig.ROUTES.sectionFromPath(pathname,appConfig.ROUTES['prematch']);
                if(!s){
                    s = appConfig.ROUTES.sectionFromPath(pathname,appConfig.ROUTES['live']);
                }
                if(s){
                    setLocation(s);
                    setIsLive(isLiveSection(s));
                    if(isLiveSection(s)){
                        appContext.setHistoryBackPressed(true);
                    }
                }else{
                    setLocation(null);
                    setIsLive(null);
                    appContext.setHistoryBackPressed(true);
                }
                
            }catch(err){
                console.log(err);
                appContext.setHistoryBackPressed(true);
            }
           
          });
    }, []);

    useEffect(() => {
        if(appContext.historyBackPressed){
            appContext.setHandleOpenFromPath(true);
        }
        appContext.setHistoryBackPressed(false);
    }, [appContext.historyBackPressed]);

    //For paths ending with '/', adding also path without '/'
   if(appConfig?.URL_PATH_MAPPINGS){
        try {
            Object.keys(appConfig.URL_PATH_MAPPINGS).forEach(p => {
                if(p?.endsWith('/') && appConfig.ROUTES.routeFromPath (p)){
                    const m = p.substring(0,p.length-1)
                    if(!appConfig.URL_PATH_MAPPINGS[m]){
                        appConfig.URL_PATH_MAPPINGS[m] = appConfig.URL_PATH_MAPPINGS[p];
                    }
                }
                
            });
        }catch(err){
            console.log(err);
        }
    }   

    return ( 
        <InitData>
            {appContext.pageNotFound ?
                <MessageInfo message={labels['general.page_not_found'] || 'Page not found'}/>
                :
                <AppContext.Provider value={appContext}>
                    <LandingRequestedOpsConf section={appContext.location.current}>
                    	<ShopReceiptPrinterConf>
	                        <ShopConf>
		                        <CashoutConfigurationCtx>
		                            <PvrConf>
		                                <UserConf  setUserLogged={setUserLogged} frontendVersion={"mobile_1"}>
	                                        <RouletteHandler></RouletteHandler>
		                                    <ControlPanelConf>
		                                        <TicketPrinterConf>
		                                            <FastbetConf>
		                                                <BonusConf>
		                                                    <BetslipConf>
		                                                        <SeoContext.Provider value={seoContext}>
                                                                    {
	                                                                	appContext.betOptionsData &&
	                                                                    	<AppModal closeFunction={()=>{appContext.hideBetOptionsModal()}} uncloseable={false} modalHeader={appContext.betOptionsData.modalHeader} modalContent={<BetOptionsModalContent betOptionsData={appContext.betOptionsData} closeFunction={()=>{appContext.hideBetOptionsModal()}}/>} />
	                                                                }		                                                        
	                                                                {appContext.betslipVariationData && 
	                                                                    <AppModal isMobile={true} uncloseable={true} modalHeader={labels?.['carrello.var_quota.warning']} modalContent={<BetslipVariation isMobile={true} betslipVariationData={appContext.betslipVariationData} closeFunction={()=>{appContext.hideBetslipVariationModal()}}/>}  />
	                                                                }
	                                                                {appContext.purchaseResponseData && 
	                                                                    <AppModal uncloseable={appContext.purchaseResponseData?.type == 'acceptance'} isMobile={true} modalHeader={labels?.['general.message']} modalContent={<PurchaseResponseMessage purchaseResponseData={appContext.purchaseResponseData} />} closeFunction={()=>{appContext.hidePurchaseMessageModal()}} />
	                                                                }
		                                                            {seoConfigFetched && !appContext.historyBackPressed && 
		                                                                <Router basename={appConfig.BASENAME}>
		                                                                    {function() {
		                                                                        const redirectTo = isLiveSection(location) ? appConfig.ROUTES['live'][location] : appConfig.ROUTES['prematch'][location];
		                                                                        const isRedirect = location != null  && redirectTo;
		                                                                        if(isRedirect){
		                                                                            appContext.setLocation(location);
		                                                                        }
		                                                                        return isRedirect  && <Redirect push={false} to={redirectTo} />
		                                                                    }()}
		                                                                    {(location == null || (appContext.location.current == location) ) &&  
		                                                                        <Switch>
		                                                                            <Route exact path="/" render={(props) => {
		                                                                                if (appConfig.ROUTES['prematch']['prematch'] === '/') {
		                                                                                    return routePrematch(props);
		                                                                                } else {
		                                                                                    return  <Redirect to={appConfig.ROUTES['prematch']['prematch']} />
		                                                                                }
		                                                                            }}/>
		                                                                            {appConfig.URL_PATH_MAPPINGS && 
		                                                                                <Route exact path={Object.keys(appConfig.URL_PATH_MAPPINGS).map(k => k.replaceAll(/\(/gm,"\\(").replaceAll(/\)/gm,"\\)"))} render={(props) => {
		                                                                                    const prematchPath = matchPath(appConfig.URL_PATH_MAPPINGS[props.match.url], {
		                                                                                        path: Object.values(appConfig.ROUTES['prematch']),
		                                                                                        exact: false,
		                                                                                        strict: false
		                                                                                    });
		                                                                                    const livePath = matchPath(appConfig.URL_PATH_MAPPINGS[props.match.url], {
		                                                                                        path: Object.values(appConfig.ROUTES['live']),
		                                                                                        exact: false,
		                                                                                        strict: false
		                                                                                    });

                                                                                            //Check live path first because may be that live page path is a sub-path of prematch page path (e.g. live=/scommesse/scommesse-live, prematch=/scommesse/)
                                                                                            if (livePath) {
		                                                                                        props.location.pathname = appConfig.URL_PATH_MAPPINGS[props.match.url];
		                                                                                        props.match = livePath;
		                                                                                        return routeLive(props);
		                                                                                    }
		                                                                                
		                                                                                    if (prematchPath) {
		                                                                                        props.location.pathname = appConfig.URL_PATH_MAPPINGS[props.match.url];
		                                                                                        props.match = prematchPath;
		                                                                                        return routePrematch(props);
		                                                                                    }
		                                                                                   
		                                                                                }}/>
		                                                                            }
		                                                                            <Route exact path={Object.values(appConfig.ROUTES['prematch'])} render={(props) => {
		                                                                                return routePrematch(props);
		                                                                            }}/>
		                                                                            <Route path={Object.values(appConfig.ROUTES['live'])} render={(props) => {
		                                                                                return routeLive(props);
		                                                                            }}/>
		                                                                            <Route exact path={Object.keys(appContext.seoRoutePath).map(function(k){return k.replaceAll(/\(/gm,"\\(").replaceAll(/\)/gm,"\\)")})} render={(props) => {
		                                                                                const originalPath = appContext.seoRoutePath[props.location.pathname]
		                                                                                const prematchPath = matchPath(originalPath, {
		                                                                                    path: Object.values(appConfig.ROUTES['prematch']),
		                                                                                    exact: false,
		                                                                                    strict: false
		                                                                                });
		                                                                                const livePath = matchPath(originalPath, {
		                                                                                    path: Object.values(appConfig.ROUTES['live']),
		                                                                                    exact: false,
		                                                                                    strict: false
		                                                                                });
		                                                                                if (prematchPath) {
		                                                                                    props.location.pathname = originalPath;
		                                                                                    props.match = prematchPath;
		                                                                                    return routePrematch(props);
		                                                                                }
		                                                                                if (livePath) {
		                                                                                    props.location.pathname = originalPath;
		                                                                                    props.match = livePath;
		                                                                                    return routeLive(props);
		                                                                                }
		                                                                            }}/>
		                                                                            <Route path={'*'} render={(props) => {
		                                                                                const prematchPath = matchPath(props.match.url, {
		                                                                                    path: Object.values(appConfig.ROUTES['prematch']),
		                                                                                    exact: false,
		                                                                                    strict: false
		                                                                                });
		                                                                                if (prematchPath) {
		                                                                                    if (handleOpenFromPath(props.match,props.location)) {
		                                                                                        props.location.pathname = props.match.url;
		                                                                                        props.match = prematchPath;
		                                                                                        return routePrematch(props);
		                                                                                    } else {
		                                                                                        return seoConfigFetched && routeNoMatching(props);
		                                                                                    }
		                                                                                } else {
		                                                                                    return seoConfigFetched && routeNoMatching(props);
		                                                                                }
		                                                                            }}/>
		                                                                        </Switch>
		                                                                    }
		                                                                </Router>
		                                                            }
		                                                        </SeoContext.Provider>
		                                                        <BetslipBottomBar />
		                                                        {appContext.showBetslip &&
	                                                                (conf.bl === 'ALT' ?
	                                                                    <BetslipAlt />
	                                                                    :
	                                                                    <Betslip />
	                                                                )
		                                                        }
		                                                        {appContext.showMyBets && appContext.isMyBetsShowable() && 
		                                                            <MyBets/>
		                                                        }
		                                                        {appContext.showCheckBet &&
		                                                            <CheckBet />
		                                                        }
	                                                            {appContext.showCheckSystemBets &&
		                                                            <CheckSystemBets />
		                                                        }
		                                                        {appContext.showFastbetPopup &&
		                                                            <FastbetPopup />
		                                                        }
		                                                        {appContext.showCheckTicketPopup &&
		                                                            <CheckTicketPopup openTicketScanner={appContext.openTicketScanner} />
		                                                        }
		                                                    </BetslipConf>
		                                                </BonusConf>
		                                            </FastbetConf>
		                                        </TicketPrinterConf>
		                                    </ControlPanelConf>
		                                </UserConf>
		                            </PvrConf>
	                            </CashoutConfigurationCtx>
	                        </ShopConf>
                        </ShopReceiptPrinterConf>
                    </LandingRequestedOpsConf> 
                </AppContext.Provider>
            }
        </InitData>
    );
}

export default App;
